import { AssignmentStatus, TuiStatusType } from '../types';

export interface StatusConfig {
  label: string;
  cssClass: string;
  tuiStatus: TuiStatusType;
}

export const STATUS_CONFIG: Record<AssignmentStatus, StatusConfig> = {
  InProgress: {
    label: 'assigner.status_in_progress',
    cssClass: 'custom_picking_up',
    tuiStatus: 'success'
  },
  Completed: {
    label: 'assigner.status_completed',
    cssClass: 'custom_finished',
    tuiStatus: 'success'
  },
  Failed: {
    label: 'assigner.status_failed',
    cssClass: '',
    tuiStatus: 'error'
  },
  Applied: {
    label: 'assigner.status_applied',
    cssClass: '',
    tuiStatus: 'info'
  },
  Initialized: {
    label: 'assigner.status_initialized',
    cssClass: '',
    tuiStatus: 'warning'
  }
};
